import { render, staticRenderFns } from "./Import.vue?vue&type=template&id=e5526534&scoped=true&"
import script from "./Import.js?vue&type=script&lang=js&"
export * from "./Import.js?vue&type=script&lang=js&"
import style0 from "./Import.css?vue&type=style&index=0&id=e5526534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5526534",
  null
  
)

export default component.exports